import React from "react";
import CustomerSalesDashboard from "./Components/CustomerSales";
import RequestSales from "./Components/RequestSales";
import QuoteSubmmitted from "./Components/QuoteSubmmitted";
import SalesOrderSales from "./Components/SalesOrderSales";
import RequestFromCustomer from "./Components/RequestFromCustomer";
import Industry from "./Components/Industry";
import Sales from "./Components/Sales";
import Approval from "./Components/Approval";
import MonthWiseSales from "./Components/MonthWiseSales";
import SalesMan from "./Components/SalesMan";
import { GetMultiNotUseRole } from "../../../../Components/Utils/roles";

function Salesindex() {
  return (
    <div className="w-full space-y-4 pb-6">
      {/* Top KPI Stat Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <CustomerSalesDashboard />
        <RequestSales />
        <QuoteSubmmitted />
        <SalesOrderSales />
      </div>

      {/* Main Charts: Monthly Sales Trend & Target vs Sales */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <MonthWiseSales />
        <Sales />
      </div>

      {/* Approvals & Salesman Performance */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Approval />
        <SalesMan />
      </div>

      {/* Request Breakdown & Industry Intelligence */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RequestFromCustomer />
        {GetMultiNotUseRole(["sales man", "sales"]) && <Industry />}
      </div>
    </div>
  );
}

export default Salesindex;
